import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';
import { Flex } from '@adobe/react-spectrum';

import getUserInitials from '../../utils/getUserInitials';
import { Container, FlexNames } from './teamStyles';

const Team = ({ team }) => {
  return (
    <Container>
      <span className="team-header">Project Team</span>
      {team &&
        team.slice(0).map(user => (
          <Flex key={user.ID}>
            <Avatar className="member-avatar">
              {getUserInitials(user.name)}
            </Avatar>
            <FlexNames>
              <span className="member-name">{user.name}</span>
              <span className="member-role">
                {user.role ? user.role.name : 'No role assigned'}
              </span>
            </FlexNames>
          </Flex>
        ))}
    </Container>
  );
};

Team.propTypes = {
  team: PropTypes.arrayOf,
};

Team.defaultProps = {
  team: '',
};
export default Team;
